export function logevent(arr, action) {
  const form = new FormData();

  form.append("arr", JSON.stringify(arr))
  form.append("action", action)

  return axios.post("/logevent", form)
}

/**
 * plugin_id: String (plugin.id)
 * post_content_id: Strnig (plugin.post_content_id)
 * post_record_id: String (post_record_id)
 */
export function logDownloadPlugin(payload) {
  const form = new FormData()
  Object.entries(payload).forEach(([key, value]) => {
    form.append(key, value)
  })
  
  return axios.post('/web-api/pluginevent', form)
}

function logDownloadPluginBIMLIB(plugin) {
  try {
    yaCounter40131035.reachGoal('SM_DOWNLOAD')
  } catch(e) {}

  const info = JSON.stringify({
    manufacturer: 'BIMLIB',
    plugin,
  })

  return logevent(
    info,
    "PLUGIN_DOWNLOAD",
  )
}

export function logDownloadPluginBIMLIBCAD() {
  return logDownloadPluginBIMLIB('CAD')
}

export function logDownloadPluginBIMLIBMaster() {
  try {
    fbq('track', 'CustomizeProduct');
  } catch (e) {}
  return logDownloadPluginBIMLIB('Master specifikaciy')
}

export function logSendEmailManufacturer(manufacturer_id, user_uuid) {
  const info = JSON.stringify({
    manufacturer_id,
    user_uuid,
  })
  return logevent(info, "SEND_EMAIL_MANUFACTURER")
}
